export default __webpack_public_path__ + "static/404-2-ead0fba9b709ce3229d7f4e28b558887.jpg";